import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { TranslocoModule } from '@jsverse/transloco';

import { CapitalizePipe } from '@hmax-order/frontend/utils';

import { ValidateFieldsService } from '../validate-fields.service';

@Component({
  selector: 'hmax-input-password',
  standalone: true,
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CapitalizePipe, CommonModule, MatFormFieldModule, MatIconModule, MatInputModule, ReactiveFormsModule, TranslocoModule],
})
export class InputPasswordComponent {
  @Input() appearance: 'fill' | 'outline' = 'outline';
  @Input() autocomplete = 'new-password';
  @Input() controlName!: string;
  @Input() formGroup!: FormGroup;
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() maxLength: number | null = null;

  visible = false;

  get formControl(): AbstractControl {
    return this.formGroup.controls[this.controlName];
  }

  public validateField = inject(ValidateFieldsService);
}
